import classes from "./ModalAction.module.css";
import Button from "../Button";
import clsx from "clsx";
const ModalAction = ({
  isApiCall,
  disabled,
  confirmText,
  isCancel = true,
  className,
  onCancel,
  type = "submit",
  onConfirm,
  leftButtonLabel = "Discard",
  leftButtonType = "secondary",
}) => {
  return (
    <div
      className={clsx(classes.btnsBox, {
        [className]: className,
      })}
    >
      {isCancel && (
        <Button
          variant={leftButtonType}
          onClick={() => {
            if (typeof onCancel === "function") onCancel();
          }}
          className={classes.cancelBtn}
        >
          {leftButtonLabel}
        </Button>
      )}
      <Button
        variant="primary"
        className={classes.confirmBtn}
        onClick={() => {
          if (typeof onConfirm === "function") onConfirm();
        }}
        type={type}
        disabled={isApiCall || disabled}
      >
        {isApiCall ? "Wait.." : confirmText ? confirmText : "Confirm"}
      </Button>
    </div>
  );
};

export default ModalAction;
